module.exports = new __parcel__URL__("swimlanes-app-skeleton.tpl.6fa567f0.svg").toString();